import { createStore } from 'vuex'
import {user} from '@/store/user'
import {app} from '@/store/app'
import {savingData} from '@/store/savingData'

const store = createStore({
  modules: {
    app,
    user,
    savingData
  }
})

window.store = store

export default store
